module.exports = __webpack_public_path__ + "static/img/dianliPic.5f537276.png";